var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "invoice" }, [
    _c(
      "div",
      { staticClass: "page-title" },
      [
        _c("custom-breadcrumb", {
          attrs: { suffix: "Invoice NO. " + _vm.invoice.invoiceCode }
        }),
        _vm._v(" "),
        _c(
          "div",
          [
            _vm.invoice["isExporting"]
              ? _c(
                  "div",
                  {
                    staticClass: "invoice-export-created",
                    attrs: {
                      title:
                        "Invoice creation after completion, the button is displayed as “Invoice”, and the invoice can be exported."
                    }
                  },
                  [_vm._v("\n           Invoice is being created\n         ")]
                )
              : _c(
                  "el-button",
                  {
                    staticClass: "invoice-export",
                    on: { click: _vm.exportInvoice }
                  },
                  [_vm._v("Export Invoice")]
                )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "invoice-header" }, [
      _c("div", { staticClass: "invoice-header-content heder-right" }, [
        _c("div", [_vm._v("Order #" + _vm._s(_vm.invoice.orderId))]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.invoice.orderDate))])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "invoice-account-table" },
      [
        _c(
          "el-table",
          { staticStyle: { width: "100%" }, attrs: { data: _vm.accountTable } },
          [
            _c("el-table-column", {
              attrs: { label: "Account #" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("el-input", {
                        on: {
                          change: function($event) {
                            return _vm.accountChange("account")
                          }
                        },
                        model: {
                          value: scope.row.account,
                          callback: function($$v) {
                            _vm.$set(scope.row, "account", $$v)
                          },
                          expression: "scope.row.account"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "brandName", label: "Brand" }
            }),
            _vm._v(" "),
            _c("el-table-column", { attrs: { prop: "date", label: "Date" } }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Salesperson" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("el-input", {
                        on: {
                          change: function($event) {
                            return _vm.accountChange("salesperson")
                          }
                        },
                        model: {
                          value: scope.row.salesperson,
                          callback: function($$v) {
                            _vm.$set(scope.row, "salesperson", $$v)
                          },
                          expression: "scope.row.salesperson"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Terms" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("el-input", {
                        on: {
                          change: function($event) {
                            return _vm.accountChange("terms")
                          }
                        },
                        model: {
                          value: scope.row.terms,
                          callback: function($$v) {
                            _vm.$set(scope.row, "terms", $$v)
                          },
                          expression: "scope.row.terms"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Ship Via" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("el-input", {
                        on: {
                          change: function($event) {
                            return _vm.accountChange("shipVia")
                          }
                        },
                        model: {
                          value: scope.row.shipVia,
                          callback: function($$v) {
                            _vm.$set(scope.row, "shipVia", $$v)
                          },
                          expression: "scope.row.shipVia"
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "invoice-description-table" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.descriptionTable }
          },
          [
            _c("el-table-column", {
              attrs: { label: "Description", "min-width": "300" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("div", { staticClass: "desc" }, [
                        _c("div", { staticClass: "desc-img" }, [
                          _c("img", {
                            attrs: { src: scope.row.skuImg, alt: "" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "desc-text" }, [
                          _c("div", [_vm._v(_vm._s(scope.row.skuName))]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(scope.row.skuParams))])
                        ])
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "brandName", label: "Brand" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "OrderPlaced" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n                  " +
                          _vm._s(scope.row.num) +
                          "\n          "
                      )
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "shipped", label: "Shipped" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("el-input", {
                        attrs: {
                          oninput:
                            "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')} if(value<=0){value=0}"
                        },
                        on: {
                          blur: function(event) {
                            return _vm.boChang(event, scope.$index, 1)
                          }
                        },
                        model: {
                          value: scope.row.shipped,
                          callback: function($$v) {
                            _vm.$set(scope.row, "shipped", $$v)
                          },
                          expression: "scope.row.shipped"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "B/O" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("el-input", {
                        attrs: {
                          oninput:
                            "if(value){value=value.replace(/^(0+)|[^\\d]+/g,'')} if(value<=0){value=0}"
                        },
                        on: {
                          blur: function(event) {
                            return _vm.boChang(event, scope.$index, 2)
                          }
                        },
                        model: {
                          value: scope.row.backOrder,
                          callback: function($$v) {
                            _vm.$set(scope.row, "backOrder", $$v)
                          },
                          expression: "scope.row.backOrder"
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "unitPriceBeforeDiscount", label: "ListPrice" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "unitPrice", label: "Disc. Price" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "commodityAmount", label: "Total" }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "invoice-footer" }, [
      _c("div", [
        _c("div", { staticClass: "invoice-footer-payment" }, [
          _vm._v("Payment method : "),
          _c("span", [_vm._v(_vm._s(_vm.invoice["payMethod"]))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "invoice-footer-memo",
            on: {
              click: function($event) {
                return _vm.openMemo(_vm.invoice.memo)
              }
            }
          },
          [
            _c("span", { staticClass: "invoice-footer-memo-title" }, [
              _vm._v("Memo")
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("span", { staticClass: "invoice-footer-memo-text" }, [
              _vm._v(
                "\n            " + _vm._s(_vm.invoice.memo) + "\n          "
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "invoice-footer-price" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "invoice-footer-price-num" }, [
          _c("div", [_vm._v(_vm._s(_vm.invoice.goodsNum))]),
          _vm._v(" "),
          _c("div", [_vm._v("$" + _vm._s(_vm.invoice.totalPriceBefore))]),
          _vm._v(" "),
          _c("div", { staticClass: "textColor-y" }, [
            _vm._v("-$" + _vm._s(_vm.invoice.productDiscounted))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "textColor-y" }, [
            _vm._v("-$" + _vm._s(_vm.invoice.orderDiscounted))
          ]),
          _vm._v(" "),
          _c("div", [_vm._v("$" + _vm._s(_vm.invoice.totalFreight))]),
          _vm._v(" "),
          _c("div", { staticClass: "textColor-r" }, [
            _vm._v("$" + _vm._s(_vm.invoice.payAmount))
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("Address", {
          ref: "address",
          attrs: { addressMessage: _vm.addressMessage }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [_c("edit-memo", { ref: "memo", attrs: { message: _vm.memoMessage } })],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", { attrs: { src: require("@/assets/img/memo.png"), alt: "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "invoice-footer-price-title" }, [
      _c("div", [_vm._v("Total quantity")]),
      _vm._v(" "),
      _c("div", [_vm._v("Total list pirce")]),
      _vm._v(" "),
      _c("div", { staticClass: "textColor-y" }, [_vm._v("Product discount")]),
      _vm._v(" "),
      _c("div", { staticClass: "textColor-y" }, [
        _vm._v("Supplier order discount")
      ]),
      _vm._v(" "),
      _c("div", [_vm._v("Shipping")]),
      _vm._v(" "),
      _c("div", { staticClass: "textColor-b" }, [_vm._v("Total Amount")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-760bb798", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760bb798","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/invoice.vue
// module id = nQdn
// module chunks = 2